module.exports = __webpack_public_path__ + "img/afpi.fedcad2d.png";